<template>
  <div class="jumping"></div>
</template>

<script setup>
import { loadingService } from '@/utils/loadingService'
loadingService.show()
</script>
